<template>
  <div class="w-full" :key="order.updated_at">
    <portal to="search">
      <div class="flex items-center">
        <h1 class="font-bold text-lg md:text-2xl">
          <inertia-link
            class="text-indigo-400 hover:text-indigo-600"
            :href="route('customer.orders')"
          >
            Customer Orders
          </inertia-link>
          <span class="text-indigo-400 font-medium">/</span>
          Order #{{ order.id }}
        </h1>
      </div>
    </portal>

    <div class="grid grid-cols-1 sm:grid-cols-12 gap-6">
      <div class="sm:col-span-12">
        <div>
          <OrderTabs
            active="payment"
            :order-id="order.id"
          />
          <OrderTabContent>
            <div class="px-4 py-5 sm:px-6 divide-y divide-gray-200 space-y-5">
              <div class="hidden sm:block">
                <h3 class="text-lg leading-6 font-medium text-gray-900">
                  Payment Information
                </h3>
              </div>
              <!-- payment information -->
              <div v-if="order.advance_payment && order.quotation_ref">
                <div>
                  <div class="sm:pt-5">
                    <div role="group">
                      <div class="sm:grid sm:grid-cols-3 sm:gap-4 sm:items-baseline">
                        <div>
                          <div class="text-base leading-6 font-medium text-gray-900 sm:text-sm sm:leading-5 sm:text-gray-700">
                            Payment Method
                          </div>
                        </div>
                        <div class="mt-4 sm:mt-0 sm:col-span-2">
                          <div class="max-w-xs">
                            <select-input :disabled="isLocked"  v-model="payment_method">
                              <option v-for="method in paymentMethods" :value="method">{{ method }}</option>
                            </select-input>
                          </div>
                          <div v-if="payment_method === 'MIB_FAISAPAY'" class="text-sm my-2">
                            Reference No: <span class="text-sm font-medium text-gray-700">{{ order.payment_reference }}</span>
                          </div>
                          <div v-if="payment_method === 'MIB_FAISAPAY' && order.payment_portal_posted_at === null">
                            <InertiaLink :href="route('customer.orders.mib-post-payment', [order.id])" class="text-sm text-blue-500 underline py-1">Post Payment to Portal</InertiaLink>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>

                <div v-if="payment_method === 'transfer'" class="mt-6 sm:mt-5">
                  <div class="sm:border-t sm:border-gray-200 sm:pt-5">
                    <div role="group">
                      <div class="sm:grid sm:grid-cols-3 sm:gap-4 sm:items-baseline">
                        <div>
                          <div class="text-base leading-6 font-medium text-gray-900 sm:text-sm sm:leading-5 sm:text-gray-700">
                            Payment Slip
                          </div>
                        </div>
                        <div class="mt-4 sm:mt-0 sm:col-span-2">
                          <div class="max-w-xs">
                            <file-input :errors="$page.props.errors.payment_slip" v-model="payment_slip"></file-input>
                            <div class="mt-4" v-if="order.customer_payment_transfer_slip_image_path">
                              <a :href="route('customer.orders.download-file', {customerOrder: order.id, file: 'payment-slip'})" target="_blank" class="btn-primary px-2.5 py-1.5">Download</a>
                            </div>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>

                <div class="mt-6 sm:mt-5" v-if="order.customer_payment_transfer_at">
                  <div class="sm:border-t sm:border-gray-200 sm:pt-5">
                    <div role="group">
                      <div class="sm:grid sm:grid-cols-3 sm:gap-4 sm:items-baseline">
                        <div>
                          <div class="text-base leading-6 font-medium text-gray-900 sm:text-sm sm:leading-5 sm:text-gray-700">
                            Customer payment updated at
                          </div>
                        </div>
                        <div class="mt-4 sm:mt-0 sm:col-span-2">
                          <div class="max-w-xs">
                            {{ order.customer_payment_transfer_at | localDateTime }}
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>

                <div class="mt-6 sm:mt-5">
                  <div class="sm:border-t sm:border-gray-200 sm:pt-5">
                    <div role="group">
                      <div class="sm:grid sm:grid-cols-3 sm:gap-4 sm:items-baseline">
                        <div>
                          <div class="text-base leading-6 font-medium text-gray-900 sm:text-sm sm:leading-5 sm:text-gray-700">
                            Payment Received at
                          </div>
                        </div>
                        <div class="mt-4 sm:mt-0 sm:col-span-2">
                          <div class="max-w-xs">
                            <date-input v-model="payment_received_at" :disabled="isLocked" :errors="$page.props.errors.payment_received_at"></date-input>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>

                <div class="m:pt-5 mt-4" v-if="!isLocked">
                  <div role="group">
                    <div class="sm:grid sm:grid-cols-3 sm:gap-4 sm:items-baseline">
                      <div>
                        <div class="text-base leading-6 font-medium text-gray-900 sm:text-sm sm:leading-5 sm:text-gray-700">
                        </div>
                      </div>
                      <div class="mt-4 sm:mt-0 sm:col-span-2">
                        <div class="max-w-xs flex items-end">
                          <div>
                            <loading-button :loading="paymentUpdating" @click="updatePayment" class="btn-primary mb-1">Update Payment</loading-button>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>

              </div>
              <!-- end of payment information -->
            </div>
          </OrderTabContent>
        </div>
      </div>
    </div>
  </div>
</template>


<script>
import Layout from "../../../Shared/Admin/Layout.vue";
import OrderTabContent from "./Partials/OrderTabContent.vue";
import OrderTabs from "./Partials/OrderTabs.vue";
import SelectInput from "../../../Shared/SelectInput.vue";
import FileInput from "../../../Shared/FileInput.vue";
import DateInput from "../../../Shared/DateInput.vue";
import LoadingButton from "../../../Shared/LoadingButton.vue";

export default {
  name: 'PaymentInformation',
  components: {LoadingButton, DateInput, FileInput, SelectInput, OrderTabs, OrderTabContent},
  layout: Layout,
  metaInfo: { title: 'Orders Payment Information' },

  props: {
    order: Object,
    paymentMethods: Array,
  },

  data() {
    return {
      paymentUpdating: false,
      payment_received_at: this.order.payment_received_at,
      payment_slip: null,
      payment_method: this.order.payment_method || 'transfer',
    }
  },

  computed: {
    isLocked() {
      if(this.canAdmin('update-orders'))
      {
        return this.order.lock;
      }
      return true;
    },
  },

  methods: {
    updatePayment() {
      this.paymentUpdating = true;


      let formData = new FormData();
      formData.append('payment_transfer_at', this.payment_transfer_at)
      formData.append('payment_received_at', this.payment_received_at)
      formData.append('payment_method', this.payment_method)
      formData.append('require_payment_slip', this.require_payment_slip === true ? 1 : 0)

      if (this.payment_slip) {
        formData.append('payment_slip', this.payment_slip);
      }

      this.$inertia.post(this.route('customer.orders.update-payment', { customerOrder: this.order.id }),  formData,{
        onFinish : () => this.paymentUpdating = false
      })
    },
  }
}
</script>
